import { pageBlockMapper } from '~/mappers/pageBlock';

import { Tabs } from './models';

export const tabsMapper = ({ pageBlock, items, ...rest }: Tabs) => ({
  pageBlock: pageBlockMapper(pageBlock),
  items: items.map((item) => ({
    ...item,
    fields: { breadcrumbs: [{ fullPath: '', title: '' }], fullPath: '' },
  })),
  ...rest,
});
